import { IBrandigApiProps } from '../services/dynamic-branding-service';

export const BOXX_BRAND: Partial<IBrandigApiProps> = {
  name: 'boxx',
  primary_color: '#0c2340',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#00b5e2',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#dd550c',
  third_color_contrast: '#ffffff',

  logo: '/assets/icon/Icon_Header_Brand.svg',
  privacy_url: 'https://myboxx.app/aviso-de-privacidad/',
  support_email: 'ladg@virket.com',
  terms_url: 'https://myboxx.app/terms-user-boxx/',
  tradename: 'Boxx',

  button_color: '#05b300',
  tab_color: '#9c9c9a',
  panel_text_color: '#ffffff',
  contrast_text_color: '#ec0000',
  default_letter_text_color: '#ffffff',
  default_letter_bg_color: '#722545',
  tab_active_color: '#ec0000',
  store_url: "",
  support_url: '',
  option_support: '',  

  contact_chart_not_specified_color: '#9d9d9c',
  contact_chart_prospect_color: '#dd550c',
  contact_chart_client_color: '#00b5e2',
  custom_background_color: '#0C2340',
  custom_title_color: '#ffffff',
  custom_icon_color: '#ffffff',
  custom_checkbox_color: '#ffffff',
  custom_label_color: '#ffffff',
  button_color_contrast: '#293a4f',
  custom_menu_color: '#ffffff',
 
  custom_color_dynamic_one : '#0C2340',
  custom_color_dynamic_two : '#ffffff',
  custom_color_dynamic_three : '#ffffff',
  custom_color_dynamic_four : '#ffffff',
  custom_color_dynamic_five : '#ffffff',
  
};

export const VENTASCLICK_BRAND: Partial<IBrandigApiProps> = {
  name: 'VentasClick',
  primary_color: '#076cf2',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#34495E',
  //secondary
  secondary_color: '#006ef5',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#194D33',
  //tertiary
  third_color: '#FBBA33',
  third_color_contrast: '#194D33',

  logo: 'https://ventasclick.com/wp-content/uploads/2021/10/cropped-Ventaclick-logo.png',
  privacy_url: 'https://ventasclick.com',
  support_email: 'soporte@ventasclick.com',
  terms_url: 'https://ventasclick.com/aviso-de-privacidad/',
  tradename: 'VentasClick',

  button_color: 'linear-gradient(#076cf2, #E9086E)',
  tab_color: '#194D33',
  panel_text_color: '#FFFFFF',
  contrast_text_color: '#194D33',
  default_letter_text_color: '#FFFFFF',
  default_letter_bg_color: 'linear-gradient(#076cf2, #E9086E)',
  tab_active_color: '#218B9A',
  store_url: "my.mitienda.pro",
  support_url: '',
  option_support: '',  

  contact_chart_not_specified_color: '#fbba33',
  contact_chart_prospect_color: 'linear-gradient(#076cf2, #E9086E)',
  contact_chart_client_color: '#218b9a',
  custom_background_color: '#ffffff',
  custom_title_color: '#34495e',
  custom_icon_color: '#ffffff',
  custom_checkbox_color: '#ffffff',
  custom_label_color: '#ffffff',
  button_color_contrast: '#ffffff',
  custom_menu_color: '#ffffff',

  custom_color_dynamic_one : '#ffffff',
  custom_color_dynamic_two : '#34495e',
  custom_color_dynamic_three : '#ffffff',
  custom_color_dynamic_four : '#ffffff',
  custom_color_dynamic_five : '#ffffff',

};

export const TODOSW_BRAND: Partial<IBrandigApiProps> = {
  name: 'TodosW',
  primary_color: '#000066',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#1d1a1a',
  //secondary
  secondary_color: '#006633',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#000000',
  //tertiary
  third_color: '#006633',
  third_color_contrast: '#000000',

  logo: 'https:\/\/boxx-crm.s3.amazonaws.com\/logos\/logo-TodosW-20221004044830.png',
  privacy_url: 'https://ventasclick.com',
  support_email: 'soporte@ventasclick.com',
  terms_url: 'https://ventasclick.com/aviso-de-privacidad/',
  tradename: 'TodosW',

  button_color: '#006633',
  tab_color: '#6B28ED',
  panel_text_color: '#FFFFFF',
  contrast_text_color: '#000000',
  default_letter_text_color: '#FFFFFF',
  default_letter_bg_color: '#000066',
  tab_active_color: '#990000',
  store_url: "",
  support_url: '',
  option_support: '',  

  contact_chart_not_specified_color: '#006633',
  contact_chart_prospect_color: '#000066',
  contact_chart_client_color: '#990000',
  custom_background_color: '#FFFFFF',
  custom_title_color: '#000066',
  custom_icon_color: '#FFFFFF',
  custom_checkbox_color: '#ffffff',
  custom_label_color: '#ffffff',
  button_color_contrast: '#000066',
  custom_menu_color: '#ffffff',
 
  custom_color_dynamic_one : '#ffffff',
  custom_color_dynamic_two : '#1d1a1a',
  custom_color_dynamic_three : '#ffffff',
  custom_color_dynamic_four : '#ffffff',
  custom_color_dynamic_five : '#ffffff',
  
};

export const GSTORE_BRAND: Partial<IBrandigApiProps> = {
  name: 'boxx',
  primary_color: '#732645',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#000000',
  //secondary
  secondary_color: '#9E3667',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1E81B0',
  //tertiary
  third_color: '#EC0000',
  third_color_contrast: '#ffffff',

  logo: 'https://boxx-crm.s3.amazonaws.com/ecwid/20220107101304.png',
  privacy_url: '',
  support_email: 'soporte.getnet@virket2593.zohodesk.com',
  terms_url: 'https://blog.getnet.store/terminos-y-condiciones-de-servicio/',
  tradename: 'GetNet',

  button_color: '#9E3667',
  tab_color: '#3A8340',
  panel_text_color: '#FFFFFF',
  contrast_text_color: '#EC0000',
  default_letter_text_color: '#ffffff',
  default_letter_bg_color: '#732645',
  tab_active_color: '#732645',
  store_url: "my.getnetstore.mx",
  support_url: '',
  option_support: '',   

  contact_chart_not_specified_color: '#732645',
  contact_chart_prospect_color: '#9E3667',
  contact_chart_client_color: '#EC0000',
  custom_background_color: '#ffffff',
  custom_title_color: '#732645',
  custom_icon_color: '#ffffff',
  custom_checkbox_color: '#ffffff',
  custom_label_color: '#ffffff',
  button_color_contrast: '#9E3667',
  custom_menu_color: '#ffffff',
 
  custom_color_dynamic_one : '#732645',
  custom_color_dynamic_two : '#ffffff',
  custom_color_dynamic_three : '#ffffff',
  custom_color_dynamic_four : '#ffffff',
  custom_color_dynamic_five : '#ffffff',
  
};

export const MND_BRAND: Partial<IBrandigApiProps> = {
  name: 'Mi negocio Digital Queretaro',
  primary_color: '#608788',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#000000',
  //secondary
  secondary_color: '#aedbda',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#FFFFFF',
  //tertiary
  third_color: '#4c8785',
  third_color_contrast: '#000000',

  logo: 'https://boxx-crm.s3.amazonaws.com/logos/logo-Mi negocio Digital Queretaro -20221014045209.png',
  privacy_url: '',
  support_email: '',
  terms_url: '',
  tradename: 'Mi negocio Digital Queretaro',

  button_color: '#1d443d',
  tab_color: '#6B28ED',
  panel_text_color: '#FFFFFF',
  contrast_text_color: '#000000',
  default_letter_text_color: '#FFFFFF',
  default_letter_bg_color: '#474548',
  tab_active_color: '#218B9A',
  store_url: "my.ecwid.com",
  support_url: '',
  option_support: '',   

  contact_chart_not_specified_color: '#006e67',
  contact_chart_prospect_color: '#79c4c2',
  contact_chart_client_color: '#dff0f0',
  custom_background_color: '#4c8785',
  custom_title_color: '#FFFFFF',
  custom_icon_color: '#FFFFFF',
  custom_checkbox_color: '#FFFFFF',
  custom_label_color: '#FFFFFF',
  button_color_contrast: '#474548',
  custom_menu_color: '#FFFFFF',
 
  custom_color_dynamic_one : '#ffffff',
  custom_color_dynamic_two : '#000000',
  custom_color_dynamic_three : '#ffffff',
  custom_color_dynamic_four : '#ffffff',
  custom_color_dynamic_five : '#ffffff',
  
};